// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Scrollbar */
.beautiful-scrollbar {
  height: calc(100vh - 170px); /* adjust based on your needs */
  overflow-y: auto;
  overflow-x: auto;
}

.dividing-border {
  height: calc(100vh - 145px); /* adjust based on your needs */
  min-width: 5px !important;
  background-color: gray;
  margin-left: 5px;
}

.beautiful-scrollbar::-webkit-scrollbar {
  width: 8px !important;
  height: 10px !important;
}

/* Track */
.beautiful-scrollbar::-webkit-scrollbar-track {
  border-radius: 10px !important;
  background-color: none !important;
}

.attempt-handler-button-styles {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 48px !important;
  letter-spacing: -0.004em;
  text-align: left;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

/* Handle */
.beautiful-scrollbar::-webkit-scrollbar-thumb {
  background: gray !important;
  border-radius: 10px !important;
}

.yesButton {
  background-color: #314cc6 !important;
  color: white !important;
}

.section-select-container {
  top: 0px;
  z-index: 1200;
  background: white;
  padding-bottom: 1rem;
}

/* Tablet responsiveness: 768px - 1024px */
@media (min-width: 768px) and (max-width: 1024px) {
  .beautiful-scrollbar {
    height: calc(100vh - 120px); /* slightly more space for header/footer */
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .dividing-border {
    height: calc(100vh - 110px);
    min-width: 3px !important;
    margin-left: 2px;
  }
  .px-5 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }
  .pt-3, .mt-3 {
    padding-top: 0.5rem !important;
    margin-top: 0.5rem !important;
  }
  .pt-2 {
    padding-top: 0.5rem !important;
  }
  .container, .container-fluid {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
  .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  /* If you want to stack panels vertically on very small tablets, add more rules here */
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/exams/style.scss"],"names":[],"mappings":"AAAA,qBAAA;AACA;EACE,2BAAA,EAAA,+BAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,2BAAA,EAAA,+BAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,uBAAA;AACF;;AAEA,UAAA;AACA;EACE,8BAAA;EACA,iCAAA;AACF;;AAEA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AACF;;AAEA,WAAA;AACA;EACE,2BAAA;EACA,8BAAA;AACF;;AAEA;EACE,oCAAA;EACA,uBAAA;AACF;;AAEA;EAEE,QAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAGA,0CAAA;AACA;EACE;IACE,2BAAA,EAAA,0CAAA;IACA,4BAAA;IACA,6BAAA;EAAF;EAEA;IACE,2BAAA;IACA,yBAAA;IACA,gBAAA;EAAF;EAEA;IACE,gCAAA;IACA,iCAAA;EAAF;EAEA;IACE,8BAAA;IACA,6BAAA;EAAF;EAEA;IACE,8BAAA;EAAF;EAEA;IACE,4BAAA;IACA,6BAAA;EAAF;EAEA;IACE,yBAAA;IACA,0BAAA;EAAF;EAEA,sFAAA;AAAF","sourcesContent":["/* Custom Scrollbar */\n.beautiful-scrollbar {\n  height: calc(100vh - 170px); /* adjust based on your needs */\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.dividing-border {\n  height: calc(100vh - 145px); /* adjust based on your needs */\n  min-width: 5px !important;\n  background-color: gray;\n  margin-left: 5px;\n}\n\n.beautiful-scrollbar::-webkit-scrollbar {\n  width: 8px !important;\n  height: 10px !important;\n}\n\n/* Track */\n.beautiful-scrollbar::-webkit-scrollbar-track {\n  border-radius: 10px !important;\n  background-color: none !important;\n}\n\n.attempt-handler-button-styles {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 48px !important;\n  letter-spacing: -0.004em;\n  text-align: left;\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n/* Handle */\n.beautiful-scrollbar::-webkit-scrollbar-thumb {\n  background: gray !important;\n  border-radius: 10px !important;\n}\n\n.yesButton {\n  background-color: #314cc6 !important;\n  color: white !important;\n}\n\n.section-select-container {\n  // position: sticky;\n  top: 0px;\n  z-index: 1200;\n  background: white;\n  padding-bottom: 1rem;\n}\n\n/* Tablet responsiveness: 768px - 1024px */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .beautiful-scrollbar {\n    height: calc(100vh - 120px); /* slightly more space for header/footer */\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n  }\n  .dividing-border {\n    height: calc(100vh - 110px);\n    min-width: 3px !important;\n    margin-left: 2px;\n  }\n  .px-5 {\n    padding-left: 0.75rem !important;\n    padding-right: 0.75rem !important;\n  }\n  .pt-3, .mt-3 {\n    padding-top: 0.5rem !important;\n    margin-top: 0.5rem !important;\n  }\n  .pt-2 {\n    padding-top: 0.5rem !important;\n  }\n  .container, .container-fluid {\n    padding-left: 2px !important;\n    padding-right: 2px !important;\n  }\n  .row {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n  /* If you want to stack panels vertically on very small tablets, add more rules here */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
